import type { HistoryResponse } from '@skinstep/shared';
import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '../lib/apiClient';

// Profile shows the 5 most recent lots up front; the rest sit behind "Show more".
// The client always sends an explicit limit, so the server-side default is unused.
// Exported so the profile reveal step matches the page size — one click reveals
// one page worth, and a network page is pulled only when the slice outruns cache.
export const HISTORY_PAGE_SIZE = 5;

export function useHistory(enabled: boolean) {
  return useInfiniteQuery({
    queryKey: ['history'],
    enabled,
    initialPageParam: null as string | null,
    queryFn: ({ pageParam, signal }) => {
      const params = new URLSearchParams({ limit: String(HISTORY_PAGE_SIZE) });
      if (pageParam != null) params.set('cursor', pageParam);
      return api.get<HistoryResponse>(`/api/lots/history?${params.toString()}`, { signal });
    },
    getNextPageParam: (lastPage) => lastPage.next_cursor,
  });
}
